<template>
	<div class="confirm-wrapper">
		<el-steps :active="2" id="steps">
			<el-step title="上传文件"></el-step>
			<el-step title="数据确认"></el-step>
			<el-step title="上传成功"></el-step>
		</el-steps>
		<el-select v-model="mode" placeholder="请选择">
			<el-option label="显示全部" value="all"></el-option>
			<el-option label="仅显示错误" value="error"></el-option>
		</el-select>
		<p id="message">
			<span>
				<span>共 {{list.length}} 条数据</span>
				&nbsp;
				<span class="color-error">{{errorList.length}} 条错误</span>
			</span>
			<span class="color-tip">
				注:鼠标移动到错误单元格上显示错误原因
			</span>
		</p>
		<div id="wrapper">
			<table class="border table-editable tableStyle">
				<tr>
					<th v-for="(column) in columns" :key="column">
						{{column}}
					</th>
				</tr>
				<tr v-for="(item, i) in filteredList" :key="i" :class="{'bg-warning': item.errors && item.errors.duplicate === true }">
					<td v-for="(column, j) in columns" :key="column + j" :title="item.errors && item.errors.fields && item.errors.fields[column]?item.errors.fields[column]:''"
					 :class="{'bg-warning': item.errors && item.errors.fields && item.errors.fields[column]}">
						<div class="inline-flex relative">
							<textarea v-model="item[column]" style=""></textarea>
							<template v-if="j === columns.length - 1">
								<i class="el-icon-circle-plus-outline tygreen operation" @click="addRow(i)"></i>
								<i class="el-icon-remove-outline tygreen operation" @click="deleteRow(i)"></i>
							</template>
						</div>
					</td>
				</tr>
			</table>
		</div>
		<el-row>
			<el-button type="primary" v-on:click="back">上一步</el-button>
			<el-button type="primary" v-on:click="submitImportConfirmData" :disabled="isDisable">确认上传</el-button>
		</el-row>
	</div>
</template>
<script>
	import supplierService from "../../../../service/supplierService";

	export default {
		components: {},
		computed: {
			columns() {
				let result = [];
				if (this.list.length === 0) {
					return result;
				}

				let first = this.list[0];
				for (let prop in first) {
					if (first.hasOwnProperty(prop) && prop !== 'errors') {
						result.push(prop);
					}
				}
				this.tableWidth = result.length * 120;
				return result;
			},
			filteredList() {
				if (this.mode === 'all') {
					return this.list;
				}
				return this.list.filter(item => item.errors);
			},
			errorList() {
				return this.list.filter(item => item.errors);
			}
		},
		data() {
			return {
				mode: 'all',
				list: [],
				tableWidth: '',
				isDisable:false,
			};
		},
		mounted() {
			this.getData();
		},
		methods: {
			async getData() {
				let transactionId = this.$route.query.transactionId;
				var that = this;
				let resp = await supplierService.getImportConfirmData(transactionId);
				var data = JSON.parse(resp.data.Data);
				data.forEach((item, index) => {
					if (item.errors) {
						item.errors = JSON.parse(item.errors);
					}
				})
				if (resp.data.Status == 1) {
					that.list = data;
				}
			},
			addRow(index) {
				this.list.splice(index + 1, 0, {});
			},
			deleteRow(index) {
				this.list.splice(index, 1);
			},
			back() {
				this.$router.go(-1);
			},
			async submitImportConfirmData() {
				this.isDisable = true;
				let transactionId = this.$route.query.transactionId;
				let list = this.list;
				list.forEach((item, index) => {
					if (item.errors) {
						delete item.errors;
					}
				})
				let resp = await supplierService.submitImportConfirmData(JSON.stringify(list), transactionId);
				if (resp.data.Status == 0) {
					this.isDisable = false;
					this.getData();
				} else {
					this.isDisable = false;
					this.$message({
						message: '保存成功',
						type: 'success'
					});
					this.$router.push({
						path: '/app/psi/sku/import/UploadSuccess',
						query: {
							count: this.list.length,
							type:'供应商',
							url:'http://i.tysoft.com/crm/html/psi/supplier/list'
						}
					})
				}
			}
		}
	};
</script>
<style>
	.color-tip{
		color:red;
	}
	textarea{
		background: transparent;
		border:none;
		resize: none;
		font-size:14px;
	}
	.tableStyle {
		table-layout: fixed;
	}

	.tableStyle th {
		width: 120px !important;
	}

	.el-row {
		text-align: center;
		margin-top: 50px;
	}

	.el-row .el-button--primary {
		background: rgba(0, 193, 200, 1);
		border: 1px solid rgba(0, 193, 200, 1);
	}

	.el-row .el-button--primary:first-child {
		margin-right: 15px;
	}

	#steps {
		margin: 50px auto !important;
	}

	.confirm-wrapper {
		margin: 0 110px 0 40px;
	}

	.confirm-wrapper table.border th,
	table.border td {
		border: 1px solid #7e7e7e;
	}

	.operation {
		font-size: 20px;
		margin-left: 8px;
		position: absolute;
		cursor: pointer;
	}

	.operation.el-icon-circle-plus-outline {
		right: -40px;
	}

	.operation.el-icon-remove-outline {
		right: -70px;
	}

	#message {
		margin-left: 5px;
		display: flex;
		justify-content: space-between;
	}

	#steps {
		width: 80%;
		margin: auto;
	}

	.wrapper {
		width: 80%;
		overflow-x: auto;
	}
	.el-select {
		width:auto;
		margin-bottom:10px;
	}
</style>
